import { enableLoginAsDealer, getLoginAsDealer, disableLoginAsDealer } from '../../helpers/api'
import swal from 'sweetalert';
// ==================================================
// INITIALIZERS
// ==================================================

const setEventListeners = () => {
    document.getElementById('CommenceSpoof').addEventListener('click', handleSpoofButton)
    document.getElementById('CeaseSpoof').addEventListener('click', handleUnspoofButton)
    document.getElementById('fname').addEventListener('keyup', clearError)
}

// ==================================================
// HANDLERS
// ==================================================

const checkSpoof = () => {
    getLoginAsDealer().then((result) => {
        const stopButton = document.getElementById('CeaseSpoof')
        const spoofLabel = document.getElementById('custNum')
        const loginas = document.getElementById('CommenceSpoof')
        if (result.data) {
            var liElement = '';
            var wrapper = document.createElement('div');
            liElement = liElement + '<p>' + result.data + '</p>';
            wrapper.innerHTML = 'Currently Login As  ' + liElement;
            liElement = '<div>' + liElement + '</div>';
            var swalOptions = {
                icon: 'info',
                buttons: ['Ok', 'Back to Dashboard'],
                dangerMode: false,
                content: wrapper,
            };
            swal(swalOptions).then((value) => {
                if (value) {
                    console.log("redirect");
                    window.location.href = "https://powerdistributors.com/portal/dashboard";
                }
            });
            stopButton.classList.remove('disabled')
            loginas.classList.add('disabled')
            spoofLabel.innerHTML = result.data
            spoofLabel.parentElement.style.display = ''

        } else {
            loginas.classList.remove('disabled')
            stopButton.classList.add('disabled')
            spoofLabel.innerHTML = ''
            spoofLabel.parentElement.style.display = 'none'
        }
    })
}

const clearError = (e) => {
    e.target.parentElement.classList.remove('spoof-error')
    document.getElementById('notFoundLabel').style.display = 'none'
}

const handleSpoofButton = async () => {
    const fname = document.getElementById('fname')
    const errorNotFoundLabel = document.getElementById('notFoundLabel')
    if (fname.value.trim()) {
        const spoofRes = await enableLoginAsDealer(fname.value)
        if (spoofRes) {
            if (spoofRes.data === 'spoofed') {
                swal('Info', 'Successfully login as dealer', 'info');
                console.log("if spoofRes", spoofRes);
                checkSpoof()
                fname.value = ''
                errorNotFoundLabel.style.display = 'none'
            } else if (spoofRes.data.length) {
                swal('Warning', spoofRes.data, 'warning');
                console.log("if else spoofRes", spoofRes);
                fname.parentElement.classList.add('spoof-error')
                fname.focus()
                errorNotFoundLabel.style.display = ''
                errorNotFoundLabel.innerHTML = spoofRes.data
            }
        }
    } else {
        fname.parentElement.classList.add('spoof-error')
        fname.focus()
    }
}

const handleUnspoofButton = async () => {
    const unspoofRes = await disableLoginAsDealer()
    console.log(unspoofRes);
    if (unspoofRes.data === '') {
        console.log(unspoofRes.data);
        checkSpoof()
    }
}

// ==================================================
// HELPERS
// ==================================================

const setForm = (result) => {
    const stopButton = document.getElementById('CeaseSpoof')
    const spoofLabel = document.getElementById('custNum')
    if (result.data) {
        stopButton.classList.remove('disabled')
        spoofLabel.innerHTML = result.data
        spoofLabel.parentElement.style.display = ''
    } else {
        stopButton.classList.add('disabled')
        spoofLabel.innerHTML = ''
        spoofLabel.parentElement.style.display = 'none'
    }
}

// ==================================================
// INIT
// ==================================================

export const init = () => {
    setEventListeners()
    checkSpoof()
}

export default init



// WEBPACK FOOTER //
// ./app/js/modules/loginAsDealer.js